import React from 'react';
import ReactTable from 'react-table';
import {Spinner, ErrorBoundary} from '@app/common';
import cx from 'classnames';
import {orderBy} from 'lodash';

interface ActionsTableProps {
    items: any[];
    isLoading: boolean;
    rowClick: any;
    original?: any;
}

export const ActionsTable = (props: ActionsTableProps) => {
    const {items} = props;

    const className = cx('-striped', 'knowledge-base-table', {
        'knowledge-base-table--has-selected-rows': false,
    });

    const orderedItems = orderBy(items, [(o) => o.title.toLowerCase()]);

    const columns = [
        {
            Header: 'Title',
            accessor: 'title',
            sortable: true,
            headerStyle: {
                marginLeft: '35px',
            },
            // eslint-disable-next-line react/display-name
            Cell: (props) => {
                return (
                    <div className={'knowledge-base-table__title-label'}>
                        {props.original.title}
                    </div>
                );
            },
            getProps: () => {
                return {
                    style: {
                        marginLeft: '35px',
                    },
                };
            },
        },
        {
            Header: 'Description',
            accessor: 'description',
            sortable: true,
            // eslint-disable-next-line react/display-name
            Cell: (props) => {
                const {original} = props;
                return (
                    <div className={'knowledge-base-table__title-label'}>
                        {original.description}
                    </div>
                );
            },
        },
    ];

    return (
        <ErrorBoundary>
            <ReactTable
                className={className}
                data={orderedItems}
                columns={columns}
                resizable={false}
                showPagination={true}
                defaultPageSize={20}
                loading={props.isLoading}
                loadingText={<Spinner />}
                getTrProps={(state, rowInfo) => ({
                    onClick: () => {
                        props.rowClick(rowInfo.original);
                    },
                })}
            />
        </ErrorBoundary>
    );
};
